'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $('input[type=checkbox], input[type=radio]', this).on('change', function () {
        var $this = $(this);

        if ($this.prop('checked')) {
            $('.input-validation-error', document).removeClass('input-validation-error');
        }
    });
};

var $ = require("jquery");

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/checkboxRadioValidation.js
// module id = 1168
// module chunks = 0